import React from 'react';
import { Helmet } from 'react-helmet-async';

export function MetaHead({ title, description, canonicalUrl, ogImage }) {
  const defaultTitle = "Den Selvejende Institution Midtgaarden";
  const finalTitle = title ? (title.includes("Midtgaarden") ? title : `${title} - ${defaultTitle}`) : defaultTitle;
  const finalDescription = description || "Midtgaarden i Bramming tilbyder helhedsorienteret misbrugsbehandling og døgnophold for mennesker med stof-, alkoholmisbrug og dobbeltdiagnose.";
  const defaultOgImage = "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/hvidmalet-bygning-med-graesplaene-og-hegn.jpg";

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={ogImage || defaultOgImage} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
